module.exports = __webpack_public_path__ + "static/media/garazh_vorota.1526309b.jpg";